import _path from 'ramda/src/path';
import React from 'react';
import ReblastContainer from '../Common/Reblast/ReblastContainer';

function ReblastDetailsAdapter() {
	const initalState = {
		CanPostComments: _path(['reblastDetails', 'CanPostComments'], window) === 'True',
		CanReadComments: _path(['reblastDetails', 'CanReadComments'], window) === 'True',
		ContentTrackingUrl: _path(['reblastDetails', 'ContentTrackingUrl'], window),
		ContentType: _path(['reblastDetails', 'ContentType'], window),
		commentsFetch: true,
		commentsDisplayCount: Infinity,
		FileAttachmentUrl: _path(['reblastDetails', 'FileAttachmentUrl'], window),
		GroupLinkPublicPage: _path(['reblastDetails', 'GroupLinkPublicPage'], window),
		GroupName: _path(['reblastDetails', 'GroupName'], window),
		HasCommented: _path(['reblastDetails', 'HasCommented'], window) === 'True',
		HasImageInAttachment: _path(['reblastDetails', 'HasImageInAttachment'], window) === 'True',
		HasFileInAttachment: _path(['reblastDetails', 'HasFileInAttachment'], window) === 'True',
		HasListing: _path(['reblastDetails', 'HasListing'], window) === 'True',
		HideFirmFeed: _path(['reblastDetails', 'HideFirmFeed'], window) === 'True',
		ImageLargeAttachmentUrl: _path(['reblastDetails', 'ImageLargeAttachmentUrl'], window),
		IsReblastOwner: _path(['reblastDetails', 'IsReblastOwner'], window) === 'True',
		IsScrubbed: _path(['reblastDetails', 'IsScrubbed'], window) === 'True',
		ListingAddress: _path(['reblastDetails', 'ListingAddress'], window),
		ListingCity: _path(['reblastDetails', 'ListingCity'], window),
		ListingCoopFeeAmount: parseInt(_path(['reblastDetails', 'ListingCoopFeeAmount'], window), 10),
		ListingCountry: _path(['reblastDetails', 'ListingCountry'], window),
		ListingCurrencyCode: _path(['reblastDetails', 'ListingCurrencyCode'], window),
		ListingFormattedPrice: _path(['reblastDetails', 'ListingFormattedPrice'], window),
		ListingFormattedPricePerAmount: _path(['reblastDetails', 'ListingFormattedPricePerAmount'], window),
		ListingHasImage: _path(['reblastDetails', 'ListingHasImage'], window) === 'True',
		ListingInteriorSize: parseInt(_path(['reblastDetails', 'ListingInteriorSize'], window), 10),
		ListingInteriorSizeUnit: parseInt(_path(['reblastDetails', 'ListingInteriorSizeUnit'], window), 10),
		ListingIsLease: _path(['reblastDetails', 'ListingTransactionType'], window) === 1,
		ListingIsSold: _path(['reblastDetails', 'ListingIsSold'], window) === 'True',
		ListingLargeImageUrl: _path(['reblastDetails', 'ListingLargeImageUrl'], window),
		ListingNumberBedrooms: parseInt(_path(['reblastDetails', 'ListingNumberBedrooms'], window), 10),
		ListingNumberBathrooms: parseInt(_path(['reblastDetails', 'ListingNumberBathrooms'], window), 10),
		ListingPrice: _path(['reblastDetails', 'ListingPrice'], window),
        ListingPricePerAmount: parseInt(_path(['reblastDetails', 'ListingPricePerAmount'], window)),
		ListingPriceSuffix: _path(['reblastDetails', 'ListingPriceSuffix'], window),
		ListingPropertySize: parseInt(_path(['reblastDetails', 'ListingPropertySize'], window), 10),
		ListingSeoUrl: _path(['reblastDetails', 'ListingSeoUrl'], window),
		ListingSoldLabel: _path(['reblastDetails', 'ListingSoldLabel'], window),
		ListingState: _path(['reblastDetails', 'ListingState'], window),
		ListingSuiteNumber2: _path(['reblastDetails', 'ListingSuiteNumber2'], window),
		ListingVirtualTourAddress: _path(['reblastDetails', 'ListingVirtualTourAddress'], window),
		ListingMarketStatus: _path(['reblastDetails', 'ListingMarketStatus'], window),
		ReblastCreatedOn: _path(['reblastDetails', 'ReblastCreatedOn'], window),
		ReblastDescription: _path(['reblastDetails', 'ReblastDescription'], window),
		ReblastId: _path(['reblastDetails', 'ReblastId'], window),
		ReblastLikeCounter: parseInt(_path(['reblastDetails', 'ReblastLikeCounter'], window),10),
		ReblastType: _path(['reblastDetails', 'ReblastType'], window),
		TotalViewCount: _path(['reblastDetails', 'TotalViewCount'], window),
		UniqueViewCount: _path(['reblastDetails', 'UniqueViewCount'], window),
		User: {
			City: _path(['reblastDetails', 'City'], window),
			FirmName: _path(['reblastDetails', 'FirmName'], window),
			FirmUniqueName: _path(['reblastDetails', 'FirmUniqueName'], window),
			FirstName: _path(['reblastDetails', 'FirstName'], window),
			LastName: _path(['reblastDetails', 'LastName'], window),
			Latitude: _path(['reblastDetails', 'UserLatitude'], window),
			Longitude: _path(['reblastDetails', 'UserLongitude'], window),
			State: _path(['reblastDetails', 'Province'], window),
			UserDomain: _path(['reblastDetails', 'UserDomain'], window),
			UserProfilePictureUrl: _path(['reblastDetails', 'UserProfilePictureUrl'], window),
			HasProfileBadge: _path(['reblastDetails', 'HasProfileBadge'], window) === 'True',
			HasPremiumPlusBadge: _path(['reblastDetails', 'HasPremiumPlusBadge'], window) === 'True',
			WebsiteId: parseInt(_path(['reblastDetails', 'UserWebsiteId'], window), 10)
		},
		UserLikedReblast: _path(['reblastDetails', 'UserLikedReblast'], window) === 'True'
	};

	return (
		<React.Fragment>
			<ReblastContainer data={initalState} />
		</React.Fragment>
	);
}

export default ReblastDetailsAdapter;
